import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChatSwitcherService } from '../chat-switcher/chat-switcher.service';
import { ChatSocketBridgeService } from './chat-socket-bridge.service';
import { ChatEffects } from './chat.effects';
import { chatReducers } from './chat.reducers';
import { CHAT_FEATURE_KEY } from './chat.state';

/**
 * Internal Chat NgRx registration (SPEC-2026-07-internal-chat, T-18).
 *
 * REGISTER ONCE, EAGERLY: this module is imported ONLY by ChatBubbleModule
 * (eager via LayoutModule), so `chatState` + ChatEffects + the socket bridge
 * exist in the root injector on every authenticated route — required because
 * the always-mounted shell surfaces (FAB badge, topbar pill, popup list)
 * consume the store before `/chat` is ever visited.
 *
 * The LAZY ChatModule must NOT import this module again: a second import in
 * the lazy injector would re-instantiate ChatEffects (duplicate effect runs →
 * duplicate HTTP calls/dispatches). Lazy components simply inject `Store` /
 * ChatSocketBridgeService, which resolve from the root injector.
 *
 * Being the single eager seam of the feature, it is also where the GLOBAL
 * quick-switcher shortcut (Ctrl/Cmd+K, T-22) is registered — one document
 * listener for the whole authenticated shell, self-gated by session +
 * `moduleChat`, so the overlay opens from `/chat`, from the bubble popup and
 * from any other route without each surface wiring its own HostListener.
 */
@NgModule({
  imports: [
    StoreModule.forFeature(CHAT_FEATURE_KEY, chatReducers),
    EffectsModule.forFeature([ChatEffects]),
  ],
  providers: [ChatSocketBridgeService],
})
export class ChatStateModule {

  constructor(chatSwitcherService: ChatSwitcherService) {
    chatSwitcherService.init();
  }
}
